import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BoolStore from '../../../stores/helpers/BoolStore';
import FuseReadOnlySwitch from '../../FuseControls/FuseReadOnlySwitch';

class ResearchModeField extends Component {
    static propTypes = {
        store: BoolStore.PropTypes,
        readOnly: PropTypes.bool,
    };

    render() {
        const { readOnly, store } = this.props;
        const tooltip = `If enabled, the user will see an option to turn on Research Mode
                         in the browser Settings menu item. Research mode allows the user
                         to change their browsing location and impersonate other browser user agents.`;
        return <FuseReadOnlySwitch
            header="Allow Research Mode"
            store={store}
            readOnly={readOnly}
            label={store.getValue() ? 'Enabled' : 'Disabled'}
            qa="research-switch"
            tooltip={tooltip}
            headerInfo={tooltip}
        />;
    }
}

export default observer(ResearchModeField);
